import { getAuth } from 'firebase/auth'
import * as Sentry from '@sentry/browser'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { readResponseJson, getResponseDebugContext } from '@/util/api/response-body'
import { ApiError } from '@/util/errors/api-error'

/** DELETE the table endpoint and validate its response contract. */
export async function deleteTable(tableId: string): Promise<void> {
  const token = await getAuth().currentUser?.getIdToken()
  if (!token) throw new Error('Sign in to access tables.')
  const url = `${kPaxtonAppApiRESTBaseUrl()}/api/v1/tables/${tableId}`
  const response = await fetch(url, {
    method: 'DELETE',
    headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
  })
  if (response.ok) return
  const { data } = await readResponseJson(response)
  const detail = data && typeof data === 'object' && 'detail' in data ? data.detail : undefined
  if (response.status >= 500) Sentry.captureException(new Error('Table request failed'), { extra: getResponseDebugContext(response, url) })
  throw new ApiError(
    response.status,
    response.status >= 400 && response.status < 500 && typeof detail === 'string' ? detail : 'Unable to delete this table.',
    response.status < 500 ? detail : undefined
  )
}
